import _ from 'lodash';

const $ = window.jQuery;

$(() => {
    const $scrollNav = $('.scroll-nav');

    if ($scrollNav.length === 0) {
        return;
    }

    const $spacer = $('.scroll-nav__spacer');
    const modules = JSON.parse($('#scroll-nav-modules')[0].innerHTML);

    let animateScrolling = false;

    if (location.hash) {
        const offset = $(location.hash).offset().top - ($('#header').height() + $('#scroll-nav').height());
        $('body').addClass('--sticky-header');
        window.scrollTo(0, offset);
    }

    function scrollTheScrollNav(el) {
        animateScrolling = true;
        const elemPos = el.getBoundingClientRect();
        const containerPos = $(
            '.scroll-nav__modules',
        )[0].getBoundingClientRect();
        let relLeftPos = elemPos.left - containerPos.left;
        if (
            $(el)
                .parent()
                .hasClass('scroll-nav__module--first')
        ) {
            relLeftPos = 0;
        }
        $('.scroll-nav__inner').animate(
            { scrollLeft: relLeftPos },
            200,
            setTimeout.bind(
                this,
                () => {
                    moveBarToLink(el);
                    animateScrolling = false;
                },
                200,
            ),
        );
    }

    function scrollToModule(id, callback) {
        animateScrolling = true;
        const offset = $(id).offset();
        const headerOffset = window.innerWidth < 720 ? 144 : 184;
        $('html,body').animate(
            { scrollTop: offset.top - headerOffset },
            500,
            callback,
        );
    }

    $('.scroll-nav__link').on('click', e => {
        e.preventDefault();
        const target = e.target;

        moveBarToLink(target);
        scrollToModule(
            $(target).attr('href'),
            scrollTheScrollNav.bind(this, target),
        );

        $('.scroll-nav__link').removeClass('-active');
        $(target).addClass('-active');
    });

    ['scroll', 'resize'].forEach(event => {
        window.addEventListener(
            event,
            _.throttle(e => {
                const rect = $spacer[0].getBoundingClientRect();
                const distance = rect.top;
                const height = $('.scroll-nav').outerHeight(true);

                if (distance - height <= 0) {
                    $scrollNav.addClass('-sticky');
                    $spacer.addClass('-sticky');
                } else {
                    $scrollNav.removeClass('-sticky');
                    $spacer.removeClass('-sticky');
                }

                if (
                    animateScrolling ||
                    $(e.target).hasClass('scroll-nav__inner')
                ) {
                    return;
                }

                const closestModule = getClosestModule();
                const closestHref = $(closestModule).attr('id');
                const elem = $(`.scroll-nav__link[href='#${closestHref}']`)[0];

                scrollTheScrollNav(elem);
            }, 300),
        );
    });

    function moveBarToLink(elem) {
        const elemPos = elem.getBoundingClientRect();
        const containerPos = $(
            '.scroll-nav__modules',
        )[0].getBoundingClientRect();
        const relLeftPos = elemPos.left - containerPos.left;
        $('.scroll-nav__active-bar').css({
            left: relLeftPos,
            width: $(elem).width(),
        });
    }

    function getClosestModule() {
        const screenCenter = $(window).scrollTop() + window.innerHeight / 2;
        let moduleCenters = [];

        _.each(modules, module => {
            const moduleHeight = $(`#${module.value}`).outerHeight(true);
            const moduleOffset = $(`#${module.value}`).offset().top;
            moduleCenters.push({
                id: module.value,
                center: moduleOffset + moduleHeight / 2,
            });
        });

        let closestModuleCenter = moduleCenters[0];

        _.each(moduleCenters, module => {
            if (
                Math.abs(screenCenter - closestModuleCenter.center) >
                Math.abs(screenCenter - module.center)
            ) {
                closestModuleCenter = module;
            }
        });

        return document.getElementById(closestModuleCenter.id);
    }

    function setMobile() {
        let innerWidth = 0;
        const $items = $('.scroll-nav__module');
        const containerWidth = $scrollNav.outerWidth(true);
        _.each($items, item => {
            innerWidth += $(item).outerWidth(true);
        });

        if (innerWidth > containerWidth) {
            if (!$scrollNav.hasClass('scroll-nav--mobile')) {
                $scrollNav.addClass('scroll-nav--mobile');
            }
        } else {
            if ($scrollNav.hasClass('scroll-nav--mobile')) {
                $scrollNav.removeClass('scroll-nav--mobile');
            }
        }
    }

    $(window).on('resize orientationchange', () => {
        setMobile();
    });

    setMobile();
    getClosestModule();
});
